import React from 'react';
import { useTranslation } from 'react-i18next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBan } from '@fortawesome/pro-solid-svg-icons/faBan';

import '../i18n/config';
import { Button } from '../Button';
import { GeneralTime } from '../constants';

interface Props {
  backgroundColor?: string;
  time: GeneralTime;
  deselectTime(time: GeneralTime): void;
  isTimeNeverSelected(time: GeneralTime): boolean;
}

export const Never = ({ backgroundColor, time, deselectTime, isTimeNeverSelected }: Props): JSX.Element => {
  const { t } = useTranslation();
  const handleNeverClick = (): void => deselectTime(time);
  const selected = (): boolean => isTimeNeverSelected(time);

  return (
    <div className='!hidden se:!inline-block h-14 align-middle'>
      <Button
        aria-label={`Never ${time.substring(4)}`}
        className={`${
          (selected() && backgroundColor) || 'bg-neutral-200'
        } w-9 h-9 sm:w-10 sm:h-10 text-center text-sm rounded-full`}
        name={`never-${time}`}
        onClick={handleNeverClick}
      >
        <span className='block leading-9 sm:leading-10'>
          <FontAwesomeIcon icon={faBan} />
        </span>
      </Button>
      <span className='block text-center uppercase text-2xs font-semibold'>
        {t('components.generalAvailability.never')}
      </span>
    </div>
  );
};
